import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { TrackingService, UserLoginEvent, UserService } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { GamingStoriesApiService } from '../gaming-stories-api/gaming-stories-api.service';
import { InstagramDataComponent } from '../instagram-data/instagram-data.component';

@Component({
    selector: 'cc-instagram-source',
    templateUrl: 'instagram-source.component.html',
    imports: [NgIf, InstagramDataComponent],
})
export class InstagramSourceComponent implements OnInit, OnDestroy {
    @Input() source: string;
    @Input() data: any;
    @Input() config: any;
    @Output() dataNotExists = new EventEmitter<string>();

    gamingData: any;
    displayInstagramStories: boolean;
    loginSubscription: Subscription;
    gamingstoriesExpirationTime: number;
    instagramHeight: any;

    constructor(
        private gamingStoriesApiService: GamingStoriesApiService,
        private user: UserService,
        private tracking: TrackingService,
    ) {}

    ngOnInit() {
        this.gamingStoriesApiService.get(this.source).subscribe((response) => {
            if (response) {
                this.gamingData = response;
                this.displayInstagramStories = true;
                this.trackGamingStories();
            }
        });
        this.loginSubscription = this.user.events.pipe(filter((e: any) => e instanceof UserLoginEvent)).subscribe(() => {
            this.gamingStoriesApiService.get(this.source).subscribe((response) => {
                if (response) {
                    this.gamingData = response;
                }
            });
        });
    }

    trackGamingStories() {
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'load',
            'component.PositionEvent': this.data ? this.data.trackPos : '', // need to change it
            'component.LocationEvent': 'not applicable',
            'component.EventDetails': 'stories section',
            'component.URLClicked': 'not applicable',
        });
    }

    ngOnDestroy() {
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
    }

    dataNotExistsEmit(data: any) {
        this.dataNotExists.emit(data);
    }
}
